export default [
    'position',
    'name',
    'price'
];
